import { render, staticRenderFns } from "./LeaveApproval.vue?vue&type=template&id=121cad8e&scoped=true"
import script from "./LeaveApproval.vue?vue&type=script&lang=js"
export * from "./LeaveApproval.vue?vue&type=script&lang=js"
import style0 from "./LeaveApproval.vue?vue&type=style&index=0&id=121cad8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121cad8e",
  null
  
)

export default component.exports